// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/timecorder.eot?t3g5qx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/timecorder.woff2?t3g5qx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/timecorder.ttf?t3g5qx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/timecorder.woff?t3g5qx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/timecorder.svg?t3g5qx", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#timecorder" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'timecorder';
    src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
      url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
      url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
      url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
  
  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'timecorder' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
  
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .icon-info-circle:before {
    content: "\\e94a";
  }
  .icon-edit-circle:before {
    content: "\\e94b";
  }
  .icon-daily:before {
    content: "\\e932";
  }
  .icon-overview:before {
    content: "\\e933";
  }
  .icon-report:before {
    content: "\\e948";
  }
  .icon-sort:before {
    content: "\\e949";
  }
  .icon-plus:before {
    content: "\\e934";
  }
  .icon-client-add:before {
    content: "\\e935";
  }
  .icon-permission-denied:before {
    content: "\\e93d";
  }
  .icon-column:before {
    content: "\\e93e";
  }
  .icon-fixed-cost:before {
    content: "\\e93f";
  }
  .icon-hide:before {
    content: "\\e940";
  }
  .icon-show:before {
    content: "\\e942";
  }
  .icon-permission-granted:before {
    content: "\\e941";
  }
  .icon-powerAdmin:before {
    content: "\\e936";
  }
  .icon-powerUser:before {
    content: "\\e937";
  }
  .icon-user:before {
    content: "\\e938";
  }
  .icon-work-add:before {
    content: "\\e939";
  }
  .icon-owner:before {
    content: "\\e93a";
  }
  .icon-delete:before {
    content: "\\e93b";
  }
  .icon-admin:before {
    content: "\\e93c";
  }
  .icon-add-cirlce:before {
    content: "\\e900";
  }
  .icon-saved:before {
    content: "\\e902";
  }
  .icon-account:before {
    content: "\\e903";
  }
  .icon-arrow-left:before {
    content: "\\e904";
  }
  .icon-arrow-right:before {
    content: "\\e905";
  }
  .icon-bold:before {
    content: "\\e906";
  }
  .icon-burger:before {
    content: "\\e907";
  }
  .icon-calendar-creation:before {
    content: "\\e908";
  }
  .icon-calendar-duration:before {
    content: "\\e909";
  }
  .icon-calendar:before {
    content: "\\e90b";
  }
  .icon-client:before {
    content: "\\e90c";
  }
  .icon-clock-fill:before {
    content: "\\e90e";
  }
  .icon-clock:before {
    content: "\\e90f";
  }
  .icon-done:before {
    content: "\\e912";
  }
  .icon-dropdown:before {
    content: "\\e913";
  }
  .icon-calendar-end:before {
    content: "\\e914";
  }
  .icon-calendar-start:before {
    content: "\\e915";
  }
  .icon-arrow-up:before {
    content: "\\e918";
  }
  .icon-arrow-down:before {
    content: "\\e919";
  }
  .icon-filter:before {
    content: "\\e91a";
  }
  .icon-fullscreen-exit:before {
    content: "\\e91b";
  }
  .icon-fullscreen-enter:before {
    content: "\\e91c";
  }
  .icon-h1:before {
    content: "\\e91d";
  }
  .icon-h2:before {
    content: "\\e91e";
  }
  .icon-help-circle:before {
    content: "\\e91f";
  }
  .icon-help:before {
    content: "\\e945";
  }
  .icon-italic:before {
    content: "\\e920";
  }
  .icon-project-add:before {
    content: "\\e921";
  }
  .icon-pencil:before {
    content: "\\e922";
  }
  .icon-pending:before {
    content: "\\e923";
  }
  .icon-progress:before {
    content: "\\e924";
  }
  .icon-project:before {
    content: "\\e925";
  }
  .icon-double-arrow-down:before {
    content: "\\e926";
  }
  .icon-double-arrow-up:before {
    content: "\\e943";
  }
  .icon-double-arrow-left:before {
    content: "\\e944";
  }
  .icon-double-arrow-right:before {
    content: "\\e927";
  }
  .icon-tag:before {
    content: "\\e928";
  }
  .icon-task-add:before {
    content: "\\e929";
  }
  .icon-task:before {
    content: "\\e92a";
  }
  .icon-text:before {
    content: "\\e92b";
  }
  .icon-underline:before {
    content: "\\e92c";
  }
  .icon-sound:before {
    content: "\\e92d";
  }
  .icon-music:before {
    content: "\\e92e";
  }
  .icon-voice:before {
    content: "\\e92f";
  }
  .icon-work:before {
    content: "\\e930";
  }
  .icon-close:before {
    content: "\\e931";
  }
  .icon-play:before {
    content: "\\e916";
  }
  .icon-play-circe:before {
    content: "\\e946";
  }
  .icon-stop:before {
    content: "\\e917";
  }
  .icon-stop-circle:before {
    content: "\\e947";
  }
  .icon-closed:before {
    content: "\\e90a";
  }
  .icon-refresh:before {
    content: "\\e901";
  }
  .icon-search:before {
    content: "\\e90d";
  }
  .icon-home:before {
    content: "\\e910";
  }
  .icon-stats:before {
    content: "\\e911";
  }
  `, "",{"version":3,"sources":["webpack://./src/css/fonts.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,6CAA2C;IAC3C;;;;2DAIgE;IAChE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,+EAA+E;IAC/E,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;;IAEd,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB","sourcesContent":["@font-face {\r\n    font-family: 'timecorder';\r\n    src:  url('../fonts/timecorder.eot?t3g5qx');\r\n    src:  url('../fonts/timecorder.eot?t3g5qx#iefix') format('embedded-opentype'),\r\n      url('../fonts/timecorder.woff2?t3g5qx') format('woff2'),\r\n      url('../fonts/timecorder.ttf?t3g5qx') format('truetype'),\r\n      url('../fonts/timecorder.woff?t3g5qx') format('woff'),\r\n      url('../fonts/timecorder.svg?t3g5qx#timecorder') format('svg');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-display: block;\r\n  }\r\n  \r\n  [class^=\"icon-\"], [class*=\" icon-\"] {\r\n    /* use !important to prevent issues with browser extensions that change fonts */\r\n    font-family: 'timecorder' !important;\r\n    speak: never;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-variant: normal;\r\n    text-transform: none;\r\n    line-height: 1;\r\n  \r\n    /* Better Font Rendering =========== */\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n  }\r\n  \r\n  .icon-info-circle:before {\r\n    content: \"\\e94a\";\r\n  }\r\n  .icon-edit-circle:before {\r\n    content: \"\\e94b\";\r\n  }\r\n  .icon-daily:before {\r\n    content: \"\\e932\";\r\n  }\r\n  .icon-overview:before {\r\n    content: \"\\e933\";\r\n  }\r\n  .icon-report:before {\r\n    content: \"\\e948\";\r\n  }\r\n  .icon-sort:before {\r\n    content: \"\\e949\";\r\n  }\r\n  .icon-plus:before {\r\n    content: \"\\e934\";\r\n  }\r\n  .icon-client-add:before {\r\n    content: \"\\e935\";\r\n  }\r\n  .icon-permission-denied:before {\r\n    content: \"\\e93d\";\r\n  }\r\n  .icon-column:before {\r\n    content: \"\\e93e\";\r\n  }\r\n  .icon-fixed-cost:before {\r\n    content: \"\\e93f\";\r\n  }\r\n  .icon-hide:before {\r\n    content: \"\\e940\";\r\n  }\r\n  .icon-show:before {\r\n    content: \"\\e942\";\r\n  }\r\n  .icon-permission-granted:before {\r\n    content: \"\\e941\";\r\n  }\r\n  .icon-powerAdmin:before {\r\n    content: \"\\e936\";\r\n  }\r\n  .icon-powerUser:before {\r\n    content: \"\\e937\";\r\n  }\r\n  .icon-user:before {\r\n    content: \"\\e938\";\r\n  }\r\n  .icon-work-add:before {\r\n    content: \"\\e939\";\r\n  }\r\n  .icon-owner:before {\r\n    content: \"\\e93a\";\r\n  }\r\n  .icon-delete:before {\r\n    content: \"\\e93b\";\r\n  }\r\n  .icon-admin:before {\r\n    content: \"\\e93c\";\r\n  }\r\n  .icon-add-cirlce:before {\r\n    content: \"\\e900\";\r\n  }\r\n  .icon-saved:before {\r\n    content: \"\\e902\";\r\n  }\r\n  .icon-account:before {\r\n    content: \"\\e903\";\r\n  }\r\n  .icon-arrow-left:before {\r\n    content: \"\\e904\";\r\n  }\r\n  .icon-arrow-right:before {\r\n    content: \"\\e905\";\r\n  }\r\n  .icon-bold:before {\r\n    content: \"\\e906\";\r\n  }\r\n  .icon-burger:before {\r\n    content: \"\\e907\";\r\n  }\r\n  .icon-calendar-creation:before {\r\n    content: \"\\e908\";\r\n  }\r\n  .icon-calendar-duration:before {\r\n    content: \"\\e909\";\r\n  }\r\n  .icon-calendar:before {\r\n    content: \"\\e90b\";\r\n  }\r\n  .icon-client:before {\r\n    content: \"\\e90c\";\r\n  }\r\n  .icon-clock-fill:before {\r\n    content: \"\\e90e\";\r\n  }\r\n  .icon-clock:before {\r\n    content: \"\\e90f\";\r\n  }\r\n  .icon-done:before {\r\n    content: \"\\e912\";\r\n  }\r\n  .icon-dropdown:before {\r\n    content: \"\\e913\";\r\n  }\r\n  .icon-calendar-end:before {\r\n    content: \"\\e914\";\r\n  }\r\n  .icon-calendar-start:before {\r\n    content: \"\\e915\";\r\n  }\r\n  .icon-arrow-up:before {\r\n    content: \"\\e918\";\r\n  }\r\n  .icon-arrow-down:before {\r\n    content: \"\\e919\";\r\n  }\r\n  .icon-filter:before {\r\n    content: \"\\e91a\";\r\n  }\r\n  .icon-fullscreen-exit:before {\r\n    content: \"\\e91b\";\r\n  }\r\n  .icon-fullscreen-enter:before {\r\n    content: \"\\e91c\";\r\n  }\r\n  .icon-h1:before {\r\n    content: \"\\e91d\";\r\n  }\r\n  .icon-h2:before {\r\n    content: \"\\e91e\";\r\n  }\r\n  .icon-help-circle:before {\r\n    content: \"\\e91f\";\r\n  }\r\n  .icon-help:before {\r\n    content: \"\\e945\";\r\n  }\r\n  .icon-italic:before {\r\n    content: \"\\e920\";\r\n  }\r\n  .icon-project-add:before {\r\n    content: \"\\e921\";\r\n  }\r\n  .icon-pencil:before {\r\n    content: \"\\e922\";\r\n  }\r\n  .icon-pending:before {\r\n    content: \"\\e923\";\r\n  }\r\n  .icon-progress:before {\r\n    content: \"\\e924\";\r\n  }\r\n  .icon-project:before {\r\n    content: \"\\e925\";\r\n  }\r\n  .icon-double-arrow-down:before {\r\n    content: \"\\e926\";\r\n  }\r\n  .icon-double-arrow-up:before {\r\n    content: \"\\e943\";\r\n  }\r\n  .icon-double-arrow-left:before {\r\n    content: \"\\e944\";\r\n  }\r\n  .icon-double-arrow-right:before {\r\n    content: \"\\e927\";\r\n  }\r\n  .icon-tag:before {\r\n    content: \"\\e928\";\r\n  }\r\n  .icon-task-add:before {\r\n    content: \"\\e929\";\r\n  }\r\n  .icon-task:before {\r\n    content: \"\\e92a\";\r\n  }\r\n  .icon-text:before {\r\n    content: \"\\e92b\";\r\n  }\r\n  .icon-underline:before {\r\n    content: \"\\e92c\";\r\n  }\r\n  .icon-sound:before {\r\n    content: \"\\e92d\";\r\n  }\r\n  .icon-music:before {\r\n    content: \"\\e92e\";\r\n  }\r\n  .icon-voice:before {\r\n    content: \"\\e92f\";\r\n  }\r\n  .icon-work:before {\r\n    content: \"\\e930\";\r\n  }\r\n  .icon-close:before {\r\n    content: \"\\e931\";\r\n  }\r\n  .icon-play:before {\r\n    content: \"\\e916\";\r\n  }\r\n  .icon-play-circe:before {\r\n    content: \"\\e946\";\r\n  }\r\n  .icon-stop:before {\r\n    content: \"\\e917\";\r\n  }\r\n  .icon-stop-circle:before {\r\n    content: \"\\e947\";\r\n  }\r\n  .icon-closed:before {\r\n    content: \"\\e90a\";\r\n  }\r\n  .icon-refresh:before {\r\n    content: \"\\e901\";\r\n  }\r\n  .icon-search:before {\r\n    content: \"\\e90d\";\r\n  }\r\n  .icon-home:before {\r\n    content: \"\\e910\";\r\n  }\r\n  .icon-stats:before {\r\n    content: \"\\e911\";\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
